import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-32 overflow-hidden bg-[#1B4332]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/00183dd2275e69ba0bcf5c89adfe32f6.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B4332] via-[#1B4332]/80 to-[#1B4332]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <p className="text-white/40 text-xs tracking-widest uppercase mb-6">Limited Time Offer</p>
        <h2 className="text-4xl md:text-6xl font-extralight text-white tracking-tight mb-6">
          現在購物，全面優惠
        </h2>
        <p className="text-white/50 text-lg mb-10 max-w-xl mx-auto">
          超過 8 件頂尖商品限時折扣最高 <strong className="text-white">23% OFF</strong>，
          加上全台免運費，錯過等一年。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/shop"
            className="inline-flex items-center justify-center px-12 py-4 bg-white text-[#1B4332] text-sm font-semibold tracking-widest hover:bg-white/90 transition-all duration-200 rounded-sm cursor-pointer whitespace-nowrap"
          >
            立即選購
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-12 py-4 border border-white/30 text-white text-sm font-medium tracking-widest hover:bg-white/5 transition-all duration-200 rounded-sm cursor-pointer whitespace-nowrap"
          >
            聯絡我們
          </Link>
        </div>
      </div>
    </section>
  );
}
